import { Autocomplete, TextField } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SELECT_VARIANTS, SIZES } from '../../constants/constants';
import { getQuickFilterSearchOptionLabel, isQuickFilterSearchOptionEqual, QuickFilterSearchOption } from './filters';
import { FilterItemProps } from './QuickFilterItem';

export default function QuickFilterSearchSingleSelectItem({
    filter,
    onFilterChanged,
    requiredFilters
}: FilterItemProps) {
    const options = useMemo<QuickFilterSearchOption[]>(
        () => filter.options.map((option) => ({ label: option })),
        [filter.options]
    );
    const isRequired = requiredFilters.includes(filter.id);
    const selected = useMemo<QuickFilterSearchOption | null>(
        () => ((filter.values || []).length ? { label: filter.values[0] } : null),
        [filter.values]
    );
    const [selectedValue, setSelectedValue] = useState<QuickFilterSearchOption | null>(selected);

    useEffect(() => {
        setSelectedValue(selected);
    }, [filter.id, selected]);

    const handleChange = useCallback(
        (_event: React.SyntheticEvent, newValue: QuickFilterSearchOption | null) => {
            setSelectedValue(newValue);
            filter.values = newValue ? [newValue.label] : [];
            onFilterChanged(filter);
        },
        [filter, onFilterChanged]
    );

    return (
        <Autocomplete
            size={SIZES.small}
            sx={{ minWidth: 150 }}
            slotProps={{ paper: { sx: { minWidth: 'fit-content' } } }}
            options={options}
            value={selectedValue}
            disableClearable={isRequired}
            isOptionEqualToValue={isQuickFilterSearchOptionEqual}
            getOptionLabel={getQuickFilterSearchOptionLabel}
            renderInput={(params) => (
                <TextField {...params} variant={SELECT_VARIANTS.standard} placeholder={filter.label} />
            )}
            onChange={handleChange}
        />
    );
}
